import type { ClientDTO } from "@/api/types/clients.types";
import { MerchantStatus } from "@/api/types/merchants.types";

const DEFAULT_MERCHANTS = [
	{
		merchantId: "merchant-001",
		merchantName: "Costa Coffee",
		merchantLogo: "",
		status: MerchantStatus.ACTIVE,
	},
	{
		merchantId: "merchant-002",
		merchantName: "Marks & Spencer",
		merchantLogo: "",
		status: MerchantStatus.ACTIVE,
	},
	{
		merchantId: "merchant-003",
		merchantName: "Sainsbury's",
		merchantLogo: "",
		status: MerchantStatus.ACTIVE,
	},
	{
		merchantId: "merchant-004",
		merchantName: "Boots",
		merchantLogo: "",
		status: MerchantStatus.ACTIVE,
	},
	{
		merchantId: "merchant-005",
		merchantName: "TfL",
		merchantLogo: "",
		status: MerchantStatus.ACTIVE,
	},
];

export const DEFAULT_CLIENTS: ClientDTO[] = [
	{
		clientId: "05cd42a6-f3a4-3df3-aafe-28a3df1322ba",
		name: "Norwich City F.C.",
		logo: "/images/norwich-city.svg",
		logoUploadedAt: "2026-01-30",
		budget: { amount: 10000, currency: "GBP" },
		merchants: DEFAULT_MERCHANTS.map((m) => ({
			...m,
			clientId: "05cd42a6-f3a4-3df3-aafe-28a3df1322ba",
		})),
	},
	{
		clientId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
		name: "Manchester United F.C.",
		logo: "/images/manchester-united.svg",
		logoUploadedAt: "2026-01-30",
		budget: { amount: 25000, currency: "GBP" },
		merchants: DEFAULT_MERCHANTS.map((m) => ({
			...m,
			clientId: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
		})),
	},
];
